// extracted by mini-css-extract-plugin
module.exports = {"products__buttons":"Products_products__buttons__g8A2f","products__button":"Products_products__button__s0VIb","products__buttonActive":"Products_products__buttonActive__sW7tk"};